import { render, staticRenderFns } from "./avatarUser.vue?vue&type=template&id=55ddef7e&"
import script from "./avatarUser.vue?vue&type=script&lang=js&"
export * from "./avatarUser.vue?vue&type=script&lang=js&"
import style0 from "./avatarUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports